var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Toolbar',{attrs:{"tooltipMessage":_vm.$t('Hier können Sie Impressum lesen.'),"toolbarTitle":_vm.translatedTitle}}),_c('v-card',[_c('v-card-text',{staticClass:"ck ck-content",domProps:{"innerHTML":_vm._s(_vm.getImpressum)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }